import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "./AuthContext";

// Guards a route by role. Defaults to admin / super_admin only.
export default function RoleRoute({ roles = ["super_admin", "admin"], children }) {
  const { user } = useAuth();
  if (user && roles.includes(user.role)) return children;

  return (
    <div className="proj-page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Not authorized</h1>
          <p className="proj-muted">You don't have access to this page.</p>
        </div>
      </div>
      <div className="proj-body">
        <div className="proj-panel">
          <p className="proj-muted">
            This section is restricted to administrators. Head back to your projects.
          </p>
          <Link className="proj-btn proj-btn-primary" to="/projects" style={{ marginTop: 12, display: "inline-flex" }}>
            Go to Projects
          </Link>
        </div>
      </div>
    </div>
  );
}
